import { store } from '@store';

import { FeatureName } from 'chaika-enums';

import { ConfigurationApi } from '@api/ConfigurationApi';
import { FeatureUpdateData } from 'chaika-frontend-types/frontend-cms';
import { DateHelper } from '@utils/DateHelper';

class FeatureToggleService {
    public async load(): Promise<void> {
        const { featureToggle: featureToggleStore } = store.configuration;
        const features = await ConfigurationApi.getFeatures();
        features.forEach(({ id, featureToggle }) => {
            featureToggleStore.setFeaturePrams(id, { ...this.getDefaultParams(), ...featureToggle });
        });
    }

    public async update(name: FeatureName, params: Partial<FeatureUpdateData>): Promise<void> {
        const { featureToggle: featureToggleStore } = store.configuration;

        const current = featureToggleStore[name];
        const newParams: FeatureUpdateData = { ...this.getDefaultParams(), ...current, ...params };

        await ConfigurationApi.updateFeature(name, newParams);

        featureToggleStore.setFeaturePrams(name, newParams);
    }

    public isAvailableForAuthUser(name: FeatureName): boolean {
        const {
            configuration: { featureToggle },
            authUser: { id, mainOrganizationId },
        } = store;

        return featureToggle.isAvailableForUser(name, id, mainOrganizationId);
    }

    public isAvailableForAll(name: FeatureName): boolean {
        return store.configuration.featureToggle[name].availableForAll;
    }

    public isAvailableForAuthUserStrict(name: FeatureName): boolean {
        const {
            configuration: { featureToggle },
            authUser: { id },
        } = store;

        return featureToggle.isAvailableForUserStrict(name, id);
    }

    private getDefaultParams(): FeatureUpdateData {
        return {
            expiredAt: DateHelper.now().toISOString(),
            availableForAll: false,
            availableForUsers: [],
            availableForOrganizations: [],
        };
    }
}

export const featureToggleService = new FeatureToggleService();
